import React, { ReactNode, useCallback, useLayoutEffect, useState } from 'react';

interface IAccordionItem {
  itemKey: number | string;
  children: string | JSX.Element | JSX.Element[];
  label?: string;
  labelEl?: ReactNode;
  defaultKey?: number | string;
  className?: string;
  bodyClassName?: string;
  expandKeys?: number[] | string[];
}

const AccordionItem: React.FC<IAccordionItem> = ({
  itemKey,
  children,
  label = '',
  labelEl,
  defaultKey,
  className = '',
  bodyClassName = '',
  expandKeys = []
}) => {
  const [isExpand, setIsExpand] = useState<boolean>(false);

  useLayoutEffect(() => {
    if ((defaultKey?.toString() && defaultKey === itemKey) || (expandKeys.length ? expandKeys.includes(itemKey as never) : false)) setIsExpand(true);
  }, [defaultKey, itemKey, expandKeys]);

  const handleExpandAccordionItem = useCallback(() => {
    setIsExpand(!isExpand);
  }, [isExpand]);

  return (
    <>
      <button
        type='button'
        className={[
          'flex w-full items-center justify-between border-b border-hl-gray-x11 text-left text-xl font-medium outline-none focus:outline-none sm:text-3xl',
          isExpand ? 'text-hl-black' : 'text-hl-gray-x11',
          className
        ].join(' ')}
        onClick={handleExpandAccordionItem}
      >
        {!labelEl ? <span>{label}</span> : labelEl}
        <svg
          fill='none'
          stroke='currentColor'
          strokeWidth='1.5'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
          aria-hidden='true'
          className={`h-6 w-6 shrink-0 transition duration-100 ease-in-out ${isExpand ? 'rotate-180' : ''}`}
        >
          <path strokeLinecap='round' strokeLinejoin='round' d='M19.5 8.25l-7.5 7.5-7.5-7.5'></path>
        </svg>
      </button>
      {isExpand ? <div className={['py-2', isExpand ? '' : 'hidden', bodyClassName].join(' ')}>{children}</div> : <></>}
    </>
  );
};

export default AccordionItem;
